import Tooltip from "@mui/material/Tooltip";
import { IoMdCopy } from "react-icons/io";
import { showToastNotification } from "../reducers/toastSlice";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { useAppDispatch as useDispatch } from "@Reducers/hooks";
import { useTranslation } from "@i18n";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";

export function useCopyToClipboard() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(
          showToastNotification({
            content: t("Copied!"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      })
      .catch((error: unknown) => {
        dispatch(
          showToastNotification({
            content: t("Cannot Copy to Clipboard - {{message}}", {
              message: error instanceof Error ? error.message : String(error),
            }),
            type: TOAST_TYPE_ERROR,
          }),
        );
        Promise.reject(error);
      });
  };
}

function CopyToClipboard(props: { text: string; style?: React.CSSProperties; children?: React.ReactNode }) {
  const { t } = useTranslation();
  const { text, style } = props;
  const handleCopy = useCopyToClipboard();

  return (
    <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} onClick={() => handleCopy(text)}>
      <Tooltip title={t("Copy to Clipboard")} placement="top" arrow>
        <span className="flex flex-row items-center gap-2" onClick={() => handleCopy(text)}>
          <IoMdCopy style={{ cursor: "pointer", fontSize: "1rem", ...style }} />
          {props.children}
        </span>
      </Tooltip>
    </ButtonComponent>
  );
}

export default CopyToClipboard;
